<template>
  <div id="comp-message" :class="{ success: msgSuccess, error: msgError }">
    <div class="msg">
      <div class="text">{{ msgText }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="close"
        @click="$emit('closeMsg')"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompMessage',
  props: ['msgText', 'msgSuccess', 'msgError']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../scss/comp-message.scss" scoped></style>
